module.exports = __webpack_public_path__ + "static/media/PegaPCSA.1df03e61.png";